<template>
  <div>
    <div class="toolbar">
      <el-select v-model="query.sourceCostId" clearable filterable placeholder="源成本" style="width:200px">
        <el-option v-for="s in costs" :key="s.sourceCostId" :label="s.sourceCostNumber + ' / ' + s.sourceCostName" :value="s.sourceCostId" />
      </el-select>
      <el-select v-model="query.moType" clearable placeholder="类型" style="width:110px">
        <el-option label="保养" value="01" />
        <el-option label="维修" value="02" />
      </el-select>
      <el-select v-model="query.moState" clearable placeholder="状态" style="width:120px">
        <el-option label="计划" value="00" />
        <el-option label="进行中" value="01" />
        <el-option label="完成" value="02" />
        <el-option label="取消" value="09" />
      </el-select>
      <el-date-picker
        v-model="dateRange" type="daterange" value-format="yyyy-MM-dd"
        start-placeholder="起" end-placeholder="止" style="width:260px"
      />
      <el-button type="primary" icon="el-icon-search" @click="search">查询</el-button>
    </div>
    <el-table :data="summary" border size="small" style="margin-bottom:16px" v-loading="loading">
      <el-table-column prop="sourceCostNumber" label="源成本编码" width="140" />
      <el-table-column prop="sourceCostName" label="源成本名称" min-width="160" />
      <el-table-column prop="orderCount" label="工单数" width="90" align="right" />
      <el-table-column prop="maintainCount" label="保养" width="80" align="right" />
      <el-table-column prop="repairCount" label="维修" width="80" align="right" />
      <el-table-column prop="plannedCount" label="计划" width="80" align="right" />
      <el-table-column prop="inProgressCount" label="进行中" width="80" align="right" />
      <el-table-column prop="finishedCount" label="完成" width="80" align="right" />
      <el-table-column prop="cancelledCount" label="取消" width="80" align="right" />
    </el-table>
    <el-table :data="list" border v-loading="loading">
      <el-table-column prop="moCode" label="工单号" width="180" />
      <el-table-column prop="sourceCostName" label="源成本" width="140" />
      <el-table-column label="类型" width="80" align="center">
        <template slot-scope="{ row }">{{ row.moType === '01' ? '保养' : '维修' }}</template>
      </el-table-column>
      <el-table-column prop="machineName" label="设备" min-width="140" />
      <el-table-column label="状态" width="90" align="center">
        <template slot-scope="{ row }">{{ stateLabel(row.moState) }}</template>
      </el-table-column>
      <el-table-column prop="planStart" label="计划开始" width="170" />
      <el-table-column prop="actualStart" label="实际开始" width="170" />
      <el-table-column prop="staffName" label="负责人" width="100" />
    </el-table>
    <list-pagination :total="total" :page="page" :page-size="pageSize" :page-sizes="[10, 20, 50, 100]" @current-change="onPage" @size-change="onSize" />
  </div>
</template>

<script>
import ListPagination from '../../components/ListPagination.vue'
import { listSourceCostReport } from '../../api/sourceCostReport'
import { selectSourceCost } from '../../api/sourceCost'

export default {
  components: { ListPagination },
  data() {
    return {
      query: { sourceCostId: '', moType: '', moState: '' },
      dateRange: null,
      summary: [], list: [], total: 0, page: 1, pageSize: 20, loading: false, costs: []
    }
  },
  created() {
    selectSourceCost().then(res => { this.costs = res.data || [] }).catch(() => {})
    this.load()
  },
  methods: {
    stateLabel(v) { return { '00': '计划', '01': '进行中', '02': '完成', '09': '取消' }[v] || v },
    search() { this.page = 1; this.load() },
    onPage(p) { this.page = p; this.load() },
    onSize(s) { this.pageSize = s; this.page = 1; this.load() },
    load() {
      this.loading = true
      const range = this.dateRange || []
      listSourceCostReport({
        currentPage: this.page, pageSize: this.pageSize,
        sourceCostId: this.query.sourceCostId, moType: this.query.moType, moState: this.query.moState,
        dateFrom: range[0] || null, dateTo: range[1] || null
      }).then(res => {
        const body = res.data || {}
        this.summary = body.summary || []
        this.list = body.list || []
        this.total = body.totalCount || 0
      }).finally(() => { this.loading = false })
    }
  }
}
</script>
